// The landing hero hands the visitor's own landing-page address to the builder as /app?page=... That address
// is theirs, not ours, and an address bar is the leakiest place to keep anything: it goes into every analytics
// event's $current_url, into the Firebase-Analytics page_view that fires at start-up, into bookmarks, into
// anything they paste to a friend, and into a referrer when they click away.
//
// So it is taken off the URL here, at module load, before analytics initialises and before any route chunk
// renders (imported at the top of main.jsx beside signinLink.js, which does the same for a sign-in code).
// Nothing else may read window.location for it (security review, PR #63: the builder's own effect was too late
// and never ran at all for a visitor who already had a draft saved).
let captured = '';

export function scrubHeroPage(win = window) {
  captured = '';                       // what THIS page load carried, so a load without one carries nothing
  try {
    const url = new URL(win.location.href);
    if (!url.searchParams.has('page')) return '';
    // The parameter goes whatever it holds: an unusable one is still ours to keep out of the bar, and leaving
    // it would make the analytics scrub the only thing standing between it and a bookmark.
    const page = (url.searchParams.get('page') || '').replace(/\s+/g, '').trim();
    captured = page.slice(0, 2048);
    url.searchParams.delete('page');
    win.history.replaceState({}, '', url.pathname + (url.search || '') + (url.hash || ''));
    return captured;
  } catch {
    return '';
  }
}

/** The address the hero handed over, or '' when this page was not opened from it. Safe to read many times;
 * the builder decides once, at mount, what to do with it. */
export function heroPage() {
  return captured;
}

scrubHeroPage();
